export default "__VITE_ASSET__CqdPheGu__"